import { differenceInDays, startOfDay } from 'date-fns';

export default function daysBetweenDateAndStartOfWeek(d: string | number | Date) {
  const weekStart = startOfDay(new Date());

  return differenceInDays(d, weekStart).toString();
}
